import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { REASON_MAX } from '../../../../Consts/licences.const';
import { ReasonDialogData, ReasonDialogResult } from '../../Interfaces/reason-dialog.interface';

@Component({
  selector: 'av-reason-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslatePipe],
  templateUrl: './av-reason-dialog.component.html',
  styleUrl: './av-reason-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvReasonDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<AvReasonDialogComponent, ReasonDialogResult>>(MatDialogRef);

  readonly data = inject<ReasonDialogData>(MAT_DIALOG_DATA);

  readonly reasonMax = REASON_MAX;

  readonly formGroup: FormGroup = this._formBuilder.group({
    reason: ['', [Validators.required, Validators.maxLength(REASON_MAX)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({ reason: String(this.formGroup.value.reason).trim() });
  }

  dismiss(): void {
    this._dialogRef.close();
  }
}
